import calc from '@/fe/calc';

declare global {
  interface Number {
    toFixedNew: (len: number) => string;
    countDecimals: (len: number) => number;
  }
}
/**
 * 扩展Number对象 实现传统的四舍五入
 * @param len 保留几位小数
 */
Number.prototype.toFixedNew = function (len: number): string {
  const n = this as number;
  return calc.toFixed(n + '', len);
};
/**
 * 扩展Number对象 获取小数位位数
 */
Number.prototype.countDecimals = function () {
  if (Math.floor(this.valueOf()) === this.valueOf()) return 0;
  return this.toString().split('.')[1].length || 0;
};

/**
 * 编码规则：截取url字符串里第一个问号与它左侧最近的/符号，取这一部分进行encodeURLComponent
 * @param url
 * @returns
 */
const encode = (url: string) => {
  if (typeof url === 'string') {
    // 取第一个问号的位置，把问号以后的部分当作参数 参数不做编码处理
    const searchPos = url.indexOf('?');
    let search = '';
    if (searchPos > -1) {
      search = url.substring(searchPos);
      url = url.substring(0, searchPos);
    }
    // 把路径的最后一部分编码
    const paths = url.split('/');
    let latest = paths[paths.length - 1];
    try {
      // 可能已经被编码处理过一次了，所以先解码再编码
      // 部分字符串在编码的时候可能会报错，需要处理一下
      latest = decodeURIComponent(latest);
    } catch (error) {}
    paths[paths.length - 1] = encodeURIComponent(latest);
    url = paths.join('/') + search;
  }
  return url;
};

// 拦截元素设置src、href属性的操作，并给值encode
// 注：div.innerHTML的方式拦截不到
const PROXY_FLAG = '__is_proxy__';
const proxyAttr = (Target: any, attr: string) => {
  if (!Target[PROXY_FLAG]) {
    const rawSet = Object.getOwnPropertyDescriptor(Target.prototype, attr)?.set;
    Object.defineProperty(Target.prototype, attr, {
      set(val) {
        val = encode(val);
        return rawSet?.call(this, val);
      }
    });
    const rawSetAttr = Target.prototype.setAttribute;
    Target.prototype.setAttribute = function (name: string, value: any) {
      if (name === attr) value = encode(value);
      return rawSetAttr?.call(this, name, value);
    };
    Object.defineProperty(Target, PROXY_FLAG, {
      get() {
        return true;
      }
    });
  }
};

const srcElements = [Image, HTMLEmbedElement, HTMLVideoElement, HTMLSourceElement];
const hrefElements = [HTMLAnchorElement];

srcElements.forEach(El => {
  proxyAttr(El, 'src');
});
hrefElements.forEach(El => {
  proxyAttr(El, 'href');
});
